export const GET_AIRDROP_BY_STATUS    =     "GET_AIRDROP_BY_STATUS";
export const GET_AIRDROP_BY_HANDLE    =     "GET_AIRDROP_BY_HANDLE";
export const GET_WHITELIST_AIRDROP_BY_ADDRESS    =     "GET_WHITELIST_AIRDROP_BY_ADDRESS";